const sectionPurchaseIncentiveCss = `
[data-type='section-purchase-incentive'] .purchase-incentive-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

[data-type='section-purchase-incentive'] .purchase-incentive {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-block: 40px;
}

[data-type='section-purchase-incentive'] .purchase-incentive p {
  margin-bottom: 0 !important;
}

[data-type='section-purchase-incentive'] .wrap-sale {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
}

[data-type='section-purchase-incentive'] .wrap-sale .wrap-sale-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
}

[data-type='section-purchase-incentive'] .wrap-sale .wrap-sale-item .dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #5ca605;
  animation: fade 1.1s ease-in-out infinite;
}

[data-type='section-purchase-incentive'] .wrap-sale .wrap-sale-item .hourglass-icon {
  width: 16px;
  height: 16px;
  color: red;
  animation: rotatePause 3s linear infinite;
}

[data-type='section-purchase-incentive'] .wrap-guarantee {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

[data-type='section-purchase-incentive'] .wrap-guarantee .wrap-guarantee-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
}

[data-type='section-purchase-incentive'] .wrap-guarantee .wrap-guarantee-item .circle-star-icon {
  width: 18px;
  height: 18px;
}

[data-type='section-purchase-incentive'] .wrap-guarantee .wrap-guarantee-item .truck-icon {
  width: 18px;
  height: 18px;
}

[data-type='section-purchase-incentive'] .wrap-order-now {
  display: flex;
  justify-content: center;
  align-items: center;
}

[data-type='section-purchase-incentive'] .wrap-order-now .btn-order-now {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 32px;
  border-radius: 10px;
  background-color: #5ca605;
  color: #fff;
  border: none;
  cursor: pointer;
  font-size: 18px;
  font-weight: bold !important;
  line-height: 24px;
  text-decoration: none;
  text-align: center;
}

[data-type='section-purchase-incentive'] .wrap-order-now .btn-order-now:hover {
  opacity: 0.8;
}

@container (max-width: 768px) {
  [data-type='section-purchase-incentive'] .purchase-incentive {
    padding-block: 16px;
  }

  [data-type='section-purchase-incentive'] .wrap-sale {
    flex-direction: column;
    gap: 10px;
  }

  [data-type='section-purchase-incentive'] .wrap-guarantee {
    flex-direction: column;
    gap: 10px;
  }

  [data-type='section-purchase-incentive'] .wrap-order-now .btn-order-now {
    padding: 12px 24px;
  }
}

@keyframes fade {
  0% {
    opacity: 1;
  }
  25% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.5;
  }
  75% {
    opacity: 0.8;
  }
  100% {
    opacity: 1;
  }
}

@keyframes rotatePause {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`;
export default sectionPurchaseIncentiveCss;
